<template>
    <section aria-label="object-weather">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.icon?.fullpath"
                    :src="apiUrl + data.icon.fullpath"
                    width="30"
                />
            </div>
            <div class="col" v-if="stepsMade === 0">
                {{ data.name }}
            </div>
            <div class="col" v-else>
                Wetter
            </div>
            <div class="col">
                <v-layout
                    style="margin: 0 !important"
                    row
                    align-center

                    class="my-10"
                >
                    <v-img
                        max-width="20"
                        class="mr-1"
                        v-if="icon"
                        :src="
                            'https://openweathermap.org/img/wn/' + icon + '.png'
                        "
                    />
                    <span class="temp">{{
                            temperature ? temperature + ' °C' : 'N/A'
                        }}</span>
                </v-layout>
            </div>
        </div>
    </section>
</template>

<script setup>
import axios from 'axios'
import { defineProps, onMounted, ref, watch } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

const temperature = ref('')
const icon = ref('')

const props = defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})

function fetchWeather() {
    axios
        .get(
            'https://api.openweathermap.org/data/2.5/forecast/daily?APPID=' +
            props.data.apiKey +
            '&units=metric&q=' +
            props.data.location +
            '&cnt=7'
        )
        .then((response) => {
            temperature.value = response.data.list[props.stepsMade].temp.day
                .toString()
                .split('.')[0]
            icon.value = response.data.list[props.stepsMade].weather[0].icon
        })
}

watch(() => props.stepsMade, () => fetchWeather())

onMounted(() => {
    fetchWeather()
})
</script>

<style lang="scss" scoped>
.temp {
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
}
</style>
